import { c as _c } from "react/compiler-runtime";
import { Button } from '@onefootprint/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTimeout } from 'usehooks-ts';
import useBrowserNotifications from '@/hooks/use-browser-notifications';
import useEnableNotifications from '../../hooks/use-enable-notifications';
const THINKING_DELAY_MS = 15000;
const SNOOZE_KEY = 'dashboard.percy-nudge-snoozed';
const readSnoozed = () => {
  if (typeof window === 'undefined') return false;
  try {
    return sessionStorage.getItem(SNOOZE_KEY) === '1';
  } catch {
    return false;
  }
};
const writeSnoozed = () => {
  try {
    sessionStorage.setItem(SNOOZE_KEY, '1');
  } catch {}
};
export type NotificationsNudgeViewProps = {
  onAllow: () => void;
  onNotNow: () => void;
  onDontAskAgain: () => void;
};
export const NotificationsNudgeView = t0 => {
  const $ = _c(32);
  const {
    onAllow,
    onNotNow,
    onDontAskAgain
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "floatingChat.notifications.nudge"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <p className="text-label-3 text-primary">{t2}</p>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t(_temp2);
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <p className="text-body-3 text-tertiary mb-3">{t4}</p>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t(_temp3);
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== onDontAskAgain || $[12] !== t6) {
    t7 = <button type="button" className="mr-auto text-caption-1 text-tertiary hover:text-secondary cursor-pointer" onClick={onDontAskAgain}>{t6}</button>;
    $[11] = onDontAskAgain;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t(_temp4);
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== onNotNow || $[17] !== t8) {
    t9 = <Button size="compact" variant="secondary" onClick={onNotNow}>{t8}</Button>;
    $[16] = onNotNow;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t) {
    t10 = t(_temp5);
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== onAllow || $[22] !== t10) {
    t11 = <Button size="compact" onClick={onAllow}>{t10}</Button>;
    $[21] = onAllow;
    $[22] = t10;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t7 || $[26] !== t9) {
    t12 = <div className="flex items-center gap-2">{t7}{t9}{t11}</div>;
    $[24] = t11;
    $[25] = t7;
    $[26] = t9;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t12 || $[29] !== t3 || $[30] !== t5) {
    t13 = <div className="w-full rounded-lg border border-tertiary bg-primary shadow-md p-4 max-md:hidden">{t3}{t5}{t12}</div>;
    $[28] = t12;
    $[29] = t3;
    $[30] = t5;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  return t13;
};
type NotificationsNudgeProps = {
  isThinking: boolean;
};
const NotificationsNudge = t0 => {
  const $ = _c(9);
  const {
    isThinking
  } = t0;
  const {
    permission,
    nudgeDismissed,
    dismissNudge
  } = useBrowserNotifications();
  const {
    enable
  } = useEnableNotifications();
  const [isSnoozed, setIsSnoozed] = useState(readSnoozed);
  const [isVisible, setIsVisible] = useState(false);
  const isRetired = permission !== "default" || nudgeDismissed;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      writeSnoozed();
      setIsSnoozed(true);
      setIsVisible(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const show = t1;
  useTimeout(show, isThinking && !isRetired && !isSnoozed ? THINKING_DELAY_MS : null);
  if (!isVisible || isRetired) {
    return null;
  }
  let t2;
  if ($[1] !== enable) {
    t2 = async () => {
      await enable();
      setIsVisible(false);
    };
    $[1] = enable;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleAllow = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setIsVisible(false);
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleNotNow = t3;
  let t4;
  if ($[4] !== dismissNudge) {
    t4 = () => {
      dismissNudge();
      setIsVisible(false);
    };
    $[4] = dismissNudge;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handleDontAskAgain = t4;
  let t5;
  if ($[6] !== handleAllow || $[7] !== handleDontAskAgain) {
    t5 = <NotificationsNudgeView onAllow={handleAllow} onNotNow={handleNotNow} onDontAskAgain={handleDontAskAgain} />;
    $[6] = handleAllow;
    $[7] = handleDontAskAgain;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
export default NotificationsNudge;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.body;
}
function _temp3($_1) {
  return $_1.dontAskAgain;
}
function _temp4($_2) {
  return $_2.notNow;
}
function _temp5($_3) {
  return $_3.allow;
}